<template>
  <div>
    <h3>Book Appointment</h3>
    <section>
      <div class="form-inline">
        <label>Consultant:</label>
        <div>{{data.name}}</div>
      </div>
      <div class="form-inline">
        <label for="startTime">Start time:</label>
        <VueCtkDateTimePicker
          v-model="start"
          :no-label="false"
          :only-date="true"
          :auto-close="true"
          :no-value-to-custom-elem="true"
          format="YYYY-MM-DD"
          formatted="ll"
        >
          <input type="text" id="startTime" :value="start" placeholder="select date" />
        </VueCtkDateTimePicker>
      </div>
      <div class="form-inline">
        <label for="hour">Hour Estimate:</label>
        <div>
          <input
            name="hour"
            id="hour"
            type="text"
            placeholder="Hour Estimate"
            v-model="editAppointment.hour"
          />
        </div>
      </div>
      <div class="form-inline">
        <label for="location">Location:</label>
        <div>
          <input
            name="location"
            id="location"
            type="text"
            placeholder="Location"
            v-model="editAppointment.location"
          />
        </div>
      </div>
      <div class="form-inline">
        <label for="task">Task:</label>
        <div>
          <input
            name="task"
            id="task"
            type="text"
            placeholder="Task"
            v-model="editAppointment.task"
          />
        </div>
      </div>
      <div class="form-inline">
        <button class="submit primary" @click="buttonClick">Book Appointment</button>
      </div>
    </section>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { date2timestamp } from "@/utils/utils";

export default {
  props: ["data"],
  data() {
    return {
      editAppointment: {
        start_time: "",
        hour: "",
        location: "",
        task: ""
      },
      start: ""
    };
  },
  components: { VueCtkDateTimePicker },
  methods: {
    buttonClick: function() {
      this.editAppointment.start_time = date2timestamp(this.start);
      let editAppointment = [];
      let tech = [];
      Object.assign(editAppointment, this.editAppointment);
      Object.assign(tech, this.tech);
      this.$emit("buttonClick", editAppointment, tech);
    }
  }
};
</script>